<!--
 Description: 用户活跃信息表 List
 Author: 作者
 Date:   2021-07-12
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="终端">
              <j-dict-select-tag v-model="queryParam.appName" placeholder="请选择终端" dictCode="sys_token,name,name"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="部门">
              <div placeholder="请输入部门" class="ant-input" aria-readonly="true" @click="xzzz" >{{orgName}}</div>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="统计时间">
              <j-date v-model="queryParam.searchDate" dateFormat="YYYY-MM"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->


    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>


      </a-table>
    </div>

    <sys-user-active-modal ref="modalForm" @ok="modalFormOk"></sys-user-active-modal>
    <user-phone-bind-left ref="modalForm4" @ok4="modalFormOk4"></user-phone-bind-left>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysUserActiveModal from './modules/SysUserActiveModal__Style#Drawer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from '../../components/dict/JDictSelectTag.vue'
  import UserPhoneBindLeft from './UserPhoneBindLeft'

  export default {
    name: 'SysUserActiveList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SysUserActiveModal,
      JDate,
      JDictSelectTag,
      UserPhoneBindLeft
    },
    data () {
      return {
        description: '用户活跃信息表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'机构',
            align:"center",
            dataIndex: 'sysOrgCode_dictText'
          },
          {
            title:'用户名',
            align:"center",
            dataIndex: 'username'
          },
          {
            title:'终端',
            align:"center",
            dataIndex: 'appName'
          },
          {
            title:'日活',
            align:"center",
            dataIndex: 'count'
          },
          {
            title:'时间',
            align:"center",
            dataIndex: 'statisticalTime'
          }
        ],
        url: {
          list: "/system/sysuseractive/page",
          delete: "/system/sysuseractive/delete",
          deleteBatch: "/system/sysuseractive/delete/batch",
          exportXlsUrl: "/system/sysuseractive/export/xls",
          importExcelUrl: "system/sysuseractive/import/excel",
          
        },
        dictOptions:{},
        orgName:""
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      xzzz:function(e){
        this.$refs.modalForm4.visible=true;
        this.$refs.modalForm4.queryTreeData();
        this.$refs.modalForm4.title="行政组织";
        this.$refs.modalForm4.disableSubmit = true;
      },
      modalFormOk4(obj){
        var departName = obj.departName;
        var orgCode = obj.orgCode;
        this.queryParam.sysOrgCode = orgCode;
        this.orgName = departName;
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>